import { render } from "./AssigneeDropdown.vue?vue&type=template&id=68c558f2&scoped=true"
import script from "./AssigneeDropdown.vue?vue&type=script&lang=js"
export * from "./AssigneeDropdown.vue?vue&type=script&lang=js"

import "./AssigneeDropdown.vue?vue&type=style&index=0&id=68c558f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c558f2"]])

export default __exports__